import { UrlApi } from "../../../../../../../../services/apirest";

const handleResponse = async (response) => {
  let data;

  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    throw {
      status: response.status,
      message: data?.error || "Error inesperado",
    };
  }

  return data;
};

export const getAplicacionesFactura = async (idFactura) => {
  const response = await fetch(
    `${UrlApi}/ctacte/recibos/facturas/aplicaciones/${idFactura}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  return handleResponse(response);
};

export const anularFactura = async (idFactura, username) => {
  const response = await fetch(
    `${UrlApi}/ctacte/recibos/aplicaciones/facturas/anular`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        idFactura,
        username,
      }),
    },
  );

  return handleResponse(response);
};
export const emitirNotaCredito = async (datos, envasado) => {
  const response = await fetch(
    `${UrlApi}/comprobantes/emitir_nc?envasado=${Number(envasado)}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(datos),
    },
  );

  return handleResponse(response);
};

export const getIDsDeAplicacionesDeUnaFactura = async (idFactura) => {
  const response = await fetch(
    `${UrlApi}/ctacte/recibos/aplicaciones/ids/${idFactura}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  return handleResponse(response);
};

export const reactivarAplicaciones = async (IDsAplicaciones = []) => {
  const response = await fetch(
    `${UrlApi}/ctacte/recibos/reactivar/aplicaciones`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ IDsAplicaciones }),
    },
  );
  return handleResponse(response);
};
